import styled from 'styled-components';
import Button from '@grnhse/seedling/lib/azalea/components/button';
import { colors } from '@grnhse/seedling/lib/azalea/constants';

export const ItalicDescription = styled.div`
  font-style: italic;
  margin-top: 4px;
  font-size: 14px;
`;

export const MediumGrey = styled.span`
  color: ${colors.mediumGrey};
`;

export const CustomFlexContainer = styled.div`
  margin-top: ${(props) => props.marginTop}px;
  margin-bottom: ${(props) => props.marginBottom}px;
  display: flex;
  justify-content: center;
  gap: 10px;
  align-items: flex-end;
  align-content: space-between;
  flex-direction: ${(props) => props.direction};
  flex-wrap: ${(props) => props.wrap};
`;

export const ExampleButton = styled(Button)`
  width: ${(props) => props.width};
  font-size: 14px;
  color: ${(props) => props.color} !important;
  background: ${(props) => props.background};
  margin-right: ${(props) => props.marginRight}px;
  margin-left: ${(props) => props.marginLeft}px;
  margin-bottom: ${(props) => props.marginBottom}px;
  && {
    opacity: 1;
  }
`;

export const DescriptionContainer = styled.div`
  width: 561px;
`;

export const ResponsiveButtonContainer = styled.div`
  width: 100%;

  button {
    width: 100%;
    max-width: 560px;
  }

  .MuiGrid-grid-xs-true {
    flex-grow: 0;
    flex-basis: auto;
  }
`;
